<template>
  <div>
    <div class="side-box__row align-items-center mt-5">
      <div class="side-box__content radio radio--help opened p-4 ml-3">
        <div
          class="d-flex align-items-center justify-content-between text-right ml-3"
        >
          <div class="align-items-center" v-html="$t('TEXT_NEW_HW_REQUEST')" />
          <a
            class="btn btn-outline-primary"
            @click="$emit('openBox', 'hwRequest')"
          >{{ $t("LINK_NEW_HW_REQUEST") }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
